import * as queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PAGES_HEAD_CONTENT from '../../../common/components/MetaData/constants';
import MetaData from '../../../common/components/MetaData/MetaData';
import { monkeyImage } from '../../../common/constants/assets';
import { trackWebAppGAEvent } from '../../../common/helpers/plugins/website-google-analytics';
import { RouterComponentProps } from '../../../common/helpers/routes/interfaces';
import { useFacebookSessionCRUDActions } from '@mm/state/actions/FacebookSessionCRUDActions';
import { selectInviteToken } from '@mm/state/selectors/userSelector';
import './LoginPage.pcss';
import { useCookies } from 'react-cookie';
import { PAP_REFERRAL_COOKIE_NAME } from '../RegisterFlow/referrals';
import { LoginForm } from '../../../modules/LoginRouter/components/LoginForm/LoginForm';
import { Badges } from '../../../modules/LoginRouter/components/LoginLayout/components/Badges/Badges';
import { SignUpLogo } from '../SignUp/SignUp/SignUpLogo/SignUpLogo';

type Props = RouterComponentProps;

export const LoginPage = (props: Props) => {
  const inviteToken = useSelector(selectInviteToken);
  const { create: createFBSession } = useFacebookSessionCRUDActions();

  const [loginPending, setLoginPending] = useState(false);

  const [cookies, ..._rest] = useCookies([PAP_REFERRAL_COOKIE_NAME]);

  useEffect(() => {
    let extraParams = {};
    try {
      const affiliateCode =
        cookies[PAP_REFERRAL_COOKIE_NAME] ||
        localStorage.getItem(PAP_REFERRAL_COOKIE_NAME);
      if (affiliateCode) {
        extraParams['affiliateCode'] = affiliateCode;
      }
    } catch {}
    if (props.location.search) {
      const params = queryString.parse(props.location.search);

      if (params.error === 'access_denied') {
        return;
      }
      if (params.email) {
        extraParams = { email: params.email };
      }
      if (params.facebookToken) {
        createFBSession({
          facebookToken: params.facebookToken as string,
          inviteToken,
          ...extraParams,
        });
        return;
      }
    }
    if (props.location.hash) {
      const params = queryString.parse(props.location.hash);
      const facebookToken = String(params.access_token);
      if (facebookToken) {
        setLoginPending(true);
        trackWebAppGAEvent('login', {
          category: 'login',
          label: 'login_success',
        });
        createFBSession({
          facebookToken,
          inviteToken,
          ...extraParams,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loginPending) {
      const loginTimeoutTimer = setTimeout(() => {
        setLoginPending(false);
      }, 2500);
      return () => clearTimeout(loginTimeoutTimer);
    }
  }, [loginPending]);

  return (
    <div className="login-page">
      <MetaData
        title={PAGES_HEAD_CONTENT.LOGIN.title}
        description={PAGES_HEAD_CONTENT.LOGIN.meta.description}
      />

      <div className="login-page__navbar">
        <SignUpLogo className="login-page__navbar-logo" />
      </div>

      <div className="login-page__wrapper">
        <div className="login-page__card">
          <Badges className="login-page__badges" />

          <LoginForm
            css={{ container: 'login-page__form' }}
            facebookLoginProps={{
              allowManualFlow: true,
              pending: loginPending,
              onClick: () => setLoginPending(true),
            }}
          />
        </div>
      </div>
    </div>
  );
};
